import { z } from "zod";

// The three built-in review types. Admins can create reviews with any type string;
// these are the ones that have rich extraction schemas in the frontend.
export const KNOWN_REVIEW_TYPES = ["ASSESSMENT", "TREATMENT", "TECHNICAL"] as const;
export type KnownReviewType = typeof KNOWN_REVIEW_TYPES[number];

// Accepts any non-empty string — custom review types are supported.
export const ReviewTypeSchema = z.string().min(1);
export type ReviewType = string;

export const ReviewSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  type: ReviewTypeSchema,
  description: z.string().nullable(),
  inclusionCriteria: z.string(),
  exclusionCriteria: z.string(),
  additionalConstraints: z.string().nullable().optional(),
  requiredReviewers: z.number().int().min(1).optional(),
  aiMaxChars: z.number().int().min(1000).optional(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Review = z.infer<typeof ReviewSchema>;

export const FilterPresetSchema = z.object({
  id: z.string().uuid(),
  reviewId: z.string().uuid().nullable(),
  name: z.string().min(1),
  description: z.string().nullable(),
  filters: z.record(z.string(), z.unknown()),
  isPublic: z.boolean(),
  sortOrder: z.number().int(),
});
export type FilterPreset = z.infer<typeof FilterPresetSchema>;

export const PrismaFlowCountsSchema = z.object({
  identified: z.number().int(),
  duplicatesRemoved: z.number().int(),
  screened: z.number().int(),
  excludedAbstract: z.number().int(),
  fullTextAssessed: z.number().int(),
  excludedFullText: z.number().int(),
  included: z.number().int(),
});
export type PrismaFlowCounts = z.infer<typeof PrismaFlowCountsSchema>;
